define(function(require,exports,module) {
	var lazyload = require('../lazyload/lazyload');

	exports.slideBox = function(opt) {
		//默认参数
		var defaults = {
			backgroundImg: false,
			directBtn: false,
			direction : 'fadein',
			duration : 0.6,//unit:seconds
			easing : 'swing',//swing,linear
			delay : 3,//unit:seconds
			startIndex : 0,
			width : 820,
			height : 360,
			id : null,
			isLazyLoad: true
		};
		var settings = $.extend(defaults, opt || {});
		if(settings.data.length == 0) {
			return false;
		}

		var wrapper = $("#" + settings.id);
        var ulWrapper = $('<div class="ulwp"></div>');
		if(wrapper.length == 0) {
			return false;
		}
		function render() {
			var items = settings.data;
			if(settings.backgroundImg) {
				var bg_id = wrapper.attr("id") + "Bg";
				var bg_div = $('<div class="background" id="'+bg_id+'"></div>');
			}


			if(settings.directBtn) {
				var directBtn = $('<a href="javascript:;" class="leftBtn"></a><a href="javascript:;" class="rightBtn"></a>');
				ulWrapper.append(directBtn);
			}

			var ul = $('<ul class="items"></ul>');

			$(items).each(function(index, item) {
				var imgUrl = item.imgUrl;
				var bgImgUrl_1 = item.bgImgUrl_1;
				var bgImgUrl_2 = item.bgImgUrl_2;
				var bgTextUrl_1 = item.bgTextUrl_1;
				var bgTextUrl_2 = item.bgTextUrl_2;
				var textUrl = item.textUrl;
				var bgColor = item.bgColor;
				var controlText = item.controlText;
				var clstag = item.clstag;

				var li = null;
				if(bgColor != "") {
					if(settings.isLazyLoad) {
						if(controlText != "") {
							li = '<li controlText="'+controlText+'" bgColor="'+bgColor+'"><a href="'+textUrl+'" clstag="'+clstag+'" target="_blank"><img data-original="'+imgUrl+'" src="" class="lazy"></a></li>';
						} else {
							li = '<li bgColor="'+bgColor+'"><a href="'+textUrl+'" clstag="'+clstag+'" target="_blank"><img data-original="'+imgUrl+'" src="" class="lazy"></a></li>';
						}
					} else {
						if(controlText != "") {
							li = '<li controlText="'+controlText+'" bgColor="'+bgColor+'"><a href="'+textUrl+'" clstag="'+clstag+'" target="_blank"><img src="'+imgUrl+'"></a></li>';
						} else {
							li = '<li bgColor="'+bgColor+'"><a href="'+textUrl+'" clstag="'+clstag+'" target="_blank"><img src="'+imgUrl+'"></a></li>';
						}
					}
				} else {
					if(settings.isLazyLoad) { 
						if(controlText != "") {
							li = '<li controlText="'+controlText+'"><a href="'+textUrl+'" clstag="'+clstag+'" target="_blank"><img data-original="'+imgUrl+'" src="" class="lazy"></a></li>';
						} else {
							li = '<li><a href="'+textUrl+'" clstag="'+clstag+'" target="_blank"><img data-original="'+imgUrl+'" src="" class="lazy"></a></li>';
						}
					} else {
						if(controlText != "") {
							li = '<li controlText="'+controlText+'"><a href="'+textUrl+'" clstag="'+clstag+'" target="_blank"><img src="'+imgUrl+'"></a></li>';
						} else {
							li = '<li><a href="'+textUrl+'" clstag="'+clstag+'" target="_blank"><img src="'+imgUrl+'"></a></li>';
						}
					}
				}

				ul.append(li);

				var bg_img = null;
				if(index == 0) {
					if(settings.isLazyLoad) {
						bg_wp = '<div class="bg-wapper curr">' +
							'<a href="'+bgTextUrl_1+'" clstag="'+clstag+'-1" target="_blank"><img data-original="'+bgImgUrl_1+'" src="" class="lazy"/></a>' +
							'<a href="'+bgTextUrl_2+'" clstag="'+clstag+'-2" target="_blank"><img data-original="'+bgImgUrl_2+'" src="" class="lazy"/></a>' +
							'</div>';
					} else {
						bg_wp = '<div class="bg-wapper curr">' +
							'<a href="'+bgTextUrl_1+'" clstag="'+clstag+'-1" target="_blank"><img src="'+bgImgUrl_1+'"/></a>' +
							'<a href="'+bgTextUrl_2+'" clstag="'+clstag+'-2" target="_blank"><img src="'+bgImgUrl_2+'"/></a>' +
							'</div>';
					}
				} else {
					if(settings.isLazyLoad) {
						bg_wp = '<div class="bg-wapper">' +
							'<a href="'+bgTextUrl_1+'" clstag="'+clstag+'-1" target="_blank"><img data-original="'+bgImgUrl_1+'" src="" class="lazy"/></a>' +
							'<a href="'+bgTextUrl_2+'" clstag="'+clstag+'-2" target="_blank"><img data-original="'+bgImgUrl_2+'" src="" class="lazy"/></a>' +
							'</div>';
					} else {
						bg_wp = '<div class="bg-wapper">' +
							'<a href="'+bgTextUrl_1+'" clstag="'+clstag+'-1" target="_blank"><img src="'+bgImgUrl_1+'"/></a>' +
							'<a href="'+bgTextUrl_2+'" clstag="'+clstag+'-2" target="_blank"><img src="'+bgImgUrl_2+'"/></a>' +
							'</div>';
					}
				}
				
				if(settings.backgroundImg) {
					bg_div.append(bg_wp);
				}
			});

            ulWrapper.append(ul);
			wrapper.append(ulWrapper);
			if(settings.backgroundImg) {
				wrapper.append(bg_div);
			}
		};
		render();
		// lazyload.fn.init();
		//计算相关数据
		var ul = wrapper.find(".ulwp").children('ul.items'), lis = ul.find('li'), firstPic = lis.first().find('img');
		var li_num = lis.size(), li_height = 0, li_width = 0;
		//定义滚动顺序:ASC/DESC
		var order_by = 'ASC';
		//初始化
		function init(){
			if(!wrapper.size()) return false;
			//手动设定值优先
			li_height = settings.height ? settings.height : lis.first().height();
			li_width = settings.width ? settings.width : lis.first().width();
			
			wrapper.css({width: li_width+'px', height:li_height+'px'});
			lis.css({/*width: li_width+'px',*/ height:li_height+'px'});
			
			ul.find('li').eq(settings.startIndex).addClass('active');
			if(lis.length != 1){
				var tips = $('<div class="tips"></div>').appendTo(ulWrapper);
				var nums = $('<div class="nums"></div>').hide().appendTo(tips);

				lis.each(function(i, n) {
					var a = $(n).find('a'),  css = '';
					i == settings.startIndex && (css = 'active');
					var txt = $(n).attr("controlText") || "";
					
					$('<a><div>'+txt+'</div></a>').addClass(css).mouseover(function(){
						var self = $(this);
						var thisLi = ul.find('li:eq('+self.index()+')');
						self.addClass('active').siblings().removeClass('active');
						thisLi.addClass('active').siblings().removeClass('active');
						var bgColor = thisLi.attr("bgColor") || "";

						if(bgColor != "") {
							wrapper.parent().css("background-color", bgColor);
							wrapper.parent().find(".slide").css("background-color", bgColor);
						}
						start(); 
						stop();
					}).appendTo(nums);
				});
				nums.show();

				wrapper.find(".rightBtn").bind("click", function() {
					start(); 
					stop();
				});

				wrapper.find(".leftBtn").bind("click", function() {
					var thisTip = wrapper.find(".nums .active");
					var thisLi = null;
					if(thisTip.prev().size()) {
						thisTip.prev().addClass("active").siblings().removeClass("active");
						thisLi = ul.find('li:eq('+(thisTip.index()-1)+')');
					} else {
						var n = thisTip.parent().children().length - 1;
						thisTip.parent().children().eq(n).addClass("active").siblings().removeClass("active");
						thisLi = ul.find('li:eq('+n+')');
					}

					thisLi.addClass('active').siblings().removeClass('active');
					var bgColor = thisLi.attr("bgColor");

					if(bgColor != "") {
						wrapper.parent().css("background-color", bgColor);
						wrapper.parent().find(".slide").css("background-color", bgColor);
					}

					start(); 
					stop();
				});
			}
			
			lis.size()>=1 && start();
		}
		//开始轮播
		function start() {
			var active = ul.find('li.active'), active_a = active.find('a');
			var index = active.index();
			if(settings.direction == 'fadein') {
				param = {};
				ul.find("li").each(function(i, item) {
					if(i != index) {
						$(item).fadeOut(300);
					}
				});
				ul.find("li").each(function(i, item) {
					if(i == index) {
						$(item).fadeIn(300);
					}
				});
			}
			wrapper.find('.nums').find('a:eq('+index+')').addClass('active').siblings().removeClass('active');

			var bgColor = active.attr("bgColor");

			if(bgColor != "") {
				wrapper.parent().css("background-color", bgColor);
				wrapper.parent().find(".slide").css("background-color", bgColor);
			}

			if(settings.backgroundImg) {
				var id = wrapper.attr("id");
				var bgId = id + "Bg";
				$("#" + bgId).find(".bg-wapper").each(function(num, item) {
					if(num === index) {
						$(item).addClass("curr");
						$(item).fadeIn(0);
					} else {
						$(item).removeClass("curr");
						$(item).fadeOut(0);
					}
				});
			}

			ul.stop().animate(param, settings.duration*1000, settings.easing, function() {
				active.removeClass('active');
				if(order_by=='ASC'){
					if (active.next().size()){
						active.next().addClass('active');
					}else{
						active.parent().children().eq(0).addClass('active');
					}
				}else if(order_by=='DESC'){
					if (active.prev().size()){
						active.prev().addClass('active');
					}else{
						order_by = 'ASC';
						var num = active.parent().children().length - 1;
						active.parent().children().eq(num).addClass('active');
					}
				}
			});
			wrapper.data('timeid', window.setTimeout(start, settings.delay*1000));

		};
		//停止轮播
		function stop() {
			window.clearTimeout(wrapper.data('timeid'));
		};

		wrapper.on("mouseenter", function(e) {
			stop();
		}).on("mouseleave", function(e) {
			wrapper.data('timeid', window.setTimeout(start, settings.delay*1000));
		});

		//首张图片加载完毕后执行初始化
		var imgLoader = new Image();
		imgLoader.onload = null;
		init();
		imgLoader.src = firstPic.attr('src');

		
	};

	exports.getImgData = function(className) {
		var slideData = {};
        slideData["data"] = [];
		$('input.' + className).each(function(index){
		     slideData["data"].push({
                "textUrl": $(this).attr("textUrl") || "",
                "imgUrl": $(this).attr("imgUrl") || "",
                "bgImgUrl_1": $(this).attr("bgImgUrl_1") || "",
                "bgImgUrl_2": $(this).attr("bgImgUrl_2") || "",
                "bgTextUrl_1": $(this).attr("bgTextUrl_1") || "",
                "bgTextUrl_2": $(this).attr("bgTextUrl_2") || "",
                "bgColor": $(this).attr("bgColor") || "",
                "controlText": $(this).attr("controlText") || "",
                "clstag": $(this).attr("clstag") || ""
            });
		}).remove();
        return slideData.data;
	};
});


// WEBPACK FOOTER //
// ./src/js/unit/slide/slideV2.js